import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'bws-alert',
    templateUrl: './bws-alert.component.html',
    styleUrls: ['./bws-alert.component.css'],
    standalone: false
})
export class BwsAlertComponent implements OnInit {

  @Input() type: 'DANGER' | 'INFO' | 'SUCCESS' | 'WARNING' = 'DANGER';
  @Input() icon = '';

  @Input()
  get light() { return this._light; }
  set light(value: any) { this._light = this.coerceBooleanProperty(value); }
  private _light?: boolean;

  @Input()
  get hideicon() { return this._hideicon; }
  set hideicon(value: any) { this._hideicon = this.coerceBooleanProperty(value); }
  private _hideicon?: boolean;

  public alertClass = 'bg-danger';
  public iconClass = '';

  ngOnInit() {

    switch (this.type) {
      case 'DANGER':
        this.alertClass = this._light ? 'alert-danger' : 'bg-danger text-white';
        this.iconClass = this._light ? 'text-danger' : '';
        this.icon = this.icon || 'alert';
        break;
      case 'INFO':
        this.alertClass = this._light ? 'alert-info' : 'bg-info text-white';
        this.iconClass = this._light ? 'text-info' : '';
        this.icon = this.icon ||  'information-outline';
        break;
      case 'SUCCESS':
        this.alertClass = this._light ? 'alert-success' : 'bg-success text-white';
        this.iconClass = this._light ? 'text-success' : '';
        this.icon = this.icon || 'check';
        break;
      case 'WARNING':
        this.alertClass = this._light ? 'alert-warning' : 'bg-warning text-white';
        this.iconClass = this._light ? 'text-warning' : '';
        this.icon = this.icon || 'alert';
        break;
    }
  }

  /** Coerces a data-bound value (typically a string) to a boolean. */
  coerceBooleanProperty(value: any): boolean {
    return value != null && `${value}` !== 'false';
  }

}
